export const sortOptions = [
  { label: 'Sort by distance (asc)', value: 'distance-asc' },
  { label: 'Sort by distance (desc)', value: 'distance-desc' },
  { label: 'Sort by price (asc)', value: 'price-asc' },
  { label: 'Sort by price (desc)', value: 'price-desc' },
  { label: 'Sort by date added (asc)', value: 'date-asc' },
  { label: 'Sort by date added (desc)', value: 'date-desc' },
  { label: 'Sort by size (asc)', value: 'size-asc' },
  { label: 'Sort by size (desc)', value: 'size-desc' }
];

export const minSearchRadiusMiles = 0.25;
